import React from 'react';
import {
  BadgeCheck,
  CalendarCheck,
  HeartHandshake,
  MessageSquareQuote,
  PiggyBank,
  ShoppingBag,
  type LucideIcon,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { NS } from '../../i18n';
import type { CampaignObjective } from '../../services/campaignsClient';
import './ObjectiveChip.css';

/**
 * One glyph per objective, the same ones the objective cards of the wizard's
 * first step carry. The chip itself is a single style for every objective: the colour
 * says "this is an objective", the icon and the word say which one.
 */
const OBJECTIVE_ICON: Record<CampaignObjective, LucideIcon> = {
  collections: PiggyBank,
  sales: ShoppingBag,
  scheduling: CalendarCheck,
  survey: MessageSquareQuote,
  retention: HeartHandshake,
  notification: BadgeCheck,
};

export interface ObjectiveChipProps {
  objective: CampaignObjective;
}

export const ObjectiveChip: React.FC<ObjectiveChipProps> = ({ objective }) => {
  const { t } = useTranslation(NS);
  const Icon = OBJECTIVE_ICON[objective];

  return (
    <span className="objective-chip">
      {Icon ? <Icon size={12} aria-hidden /> : null}
      {t(`objective.${objective}`)}
    </span>
  );
};
